import { MultipleSelect, MultipleSelectProps } from './MultipleSelect';

export type CreatableMultipleSelectProps<T = string | null> = MultipleSelectProps<T>;

export const CreatableMultipleSelect = <T = string | null>(props: CreatableMultipleSelectProps<T>) => {
  return <MultipleSelect {...props} allowCustomOption={true} />;
};
